var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-autenticacao'),_c('AppCarregando'),_c('AppMensagem'),_c('v-main',[_c('router-view')],1),_c('Menu',{attrs:{"titulo":this.$route.meta.tituloMenu === undefined
                ? _vm.titulo
                : this.$route.meta.tituloMenu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }